import type { ExcelGridRowCellsProps } from "../models/excel-grid-component-props.models";
import { ExcelGridCell } from "./ExcelGridCell";

export const ExcelGridRowCells = ({
  row,
  rowIndex,
  columns,
  rowHeight,
  dataTest,
  editing,
  selection,
  selectedCellRef,
  onCancelEditing,
  onCommitEditing,
  onCommitEditingValue,
  onEditValueChange,
  onFocusGrid,
  onStartEditing,
  onSelectionChange,
  isSavingCell,
  cellEditorMode,
  selectMenuPortalTarget,
}: ExcelGridRowCellsProps) => (
  <>
    {columns.map((column, columnIndex) => {
      const isSelected = selection.rowIndex === rowIndex && selection.columnIndex === columnIndex;
      const isEditing = editing?.rowIndex === rowIndex && editing.columnIndex === columnIndex;

      return (
        <ExcelGridCell
          key={column.key}
          row={row}
          column={column}
          rowHeight={rowHeight}
          rowIndex={rowIndex}
          columnIndex={columnIndex}
          dataTest={dataTest}
          isEditing={isEditing}
          isSelected={isSelected}
          isSaving={isSavingCell?.(row, column) ?? false}
          editValue={editing?.value ?? ""}
          selectedCellRef={isSelected ? selectedCellRef : undefined}
          onCancelEditing={onCancelEditing}
          onCommitEditing={onCommitEditing}
          onCommitEditingValue={onCommitEditingValue}
          onEditValueChange={onEditValueChange}
          onFocusGrid={onFocusGrid}
          onStartEditing={onStartEditing}
          onSelectionChange={onSelectionChange}
          cellEditorMode={cellEditorMode}
          selectMenuPortalTarget={selectMenuPortalTarget}
        />
      );
    })}
  </>
);
